module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    class: _vm.classValue,
    style: (_vm.clsStyle),
    attrs: {
      "type": _vm.type,
      "icon": _vm.activeIcon,
      "size": _vm.size,
      "disabled": _vm.isViewOnly(),
      "text": _vm.btnStyle === 'text' ? true : false,
      "plain": _vm.btnStyle === 'plain' ? true : false,
      "round": _vm.round,
      "circle": _vm.circle
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n     "), (this.$slots && !this.isEmptyObject(this.$slots)) ? _vm._t("default") : _c('span', [_vm._v("\n       " + _vm._s(_vm.text) + "\n    ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57376328"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/files/DownloadButton.vue
// module id = 1575
// module chunks = 0